/**
 * @file
 * Accordion functionality.
 */

(($, { behaviors }) => {
  /**
   * Page scroll to opened accordion
   *
   * @param {Element} $element
   *   An element to scroll to.
   */
  function pageScroll($element) {
    const $window = $("html, body");
    const scrollToPosition = $element.offset().top - 120;

    $window.animate({ scrollTop: scrollToPosition }, 500);
  }

  /**
   * Toggle content of an accordion.
   *
   * @param {jQuery} $accordion
   *   An accordion DOM element.
   */
  function toggleAccordion($accordion) {
    const $accordionToggle = $accordion.find(".js-accordion__toggle");
    const $accordionContent = $accordion.find(".js-accordion__content");
    $accordion.toggleClass("is-expanded");
    $accordionContent.slideToggle(225);
    const accordionIsExpanded = $accordion.hasClass("is-expanded");

    if (accordionIsExpanded) {
      $accordionToggle.attr("aria-expanded", "true");
      const accordionId = $accordion.data("accordion-id");
      window.location.hash = `#accordion=${accordionId}`;
    } else {
      $accordionToggle.attr("aria-expanded", "false");
      // Clear hash when closing accordion
      const newUrl = window.location.pathname + window.location.search;
      window.history.replaceState({}, "", newUrl);
    }
  }

  /**
   * Open content of an accordion on page load.
   *
   * @param {jQuery} $accordion
   *   An accordion DOM element.
   */
  function openAccordionOnPageLoad($accordion) {
    if ($accordion.length && !$accordion.hasClass("is-expanded")) {
      // For education offering accordion that is predefined as open - close it
      const $openedAccordion = $(".education-offering-accordion.is-expanded");
      if ($openedAccordion.length) {
        $openedAccordion.removeClass("is-expanded");
        $openedAccordion
          .find(".js-accordion__toggle")
          .attr("aria-expanded", "false");
        $openedAccordion.find(".js-accordion__content").css("display", "none");
      }

      // Open the accordion from URL hash
      $accordion.addClass("is-expanded");
      $accordion.find(".js-accordion__toggle").attr("aria-expanded", "true");
      $accordion.find(".js-accordion__content").css("display", "block");
      pageScroll($accordion);
    } else if ($accordion.length) {
      pageScroll($accordion);
    }
  }

  /**
   * Check for accordion hash in the URL and open it if is present.
   */
  function accordionHashOnPageLoad() {
    const urlHash = window.location && window.location.hash;
    const accordionHash = urlHash.split("accordion=")[1];

    if (accordionHash) {
      const accordion = document.querySelector(
        `[data-accordion-id="${accordionHash}"]`
      );
      openAccordionOnPageLoad($(accordion));
    }
  }

  /**
   * Attaches behaviors for accordion.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *  Attaches accordion functionality.
   */
  behaviors.accordion = {
    attach(context) {
      const $accordionToggle = $(".js-accordion__toggle", context);

      $accordionToggle.on("click", (event) => {
        event.stopImmediatePropagation(); // Stop event propagation
        const $targetedAccordionToggle = $(event.currentTarget);
        const $accordion = $targetedAccordionToggle.closest(".js-accordion");

        toggleAccordion($accordion);
      });

      // Read potential accordion hash on page load.
      accordionHashOnPageLoad();
    },
  };
})(jQuery, Drupal);
